import React, { useState } from 'react';
import ItemsListContainer from '../ItemListContainer/ItemsListContainer';
import "../Welcome/Welcome.css";
import { Container, Button, Modal } from 'react-bootstrap';
import Hora from './Hora';
import PromotionCarousel from '../Promotion/PromotionCarousel';
import HorarioSucursal from './HorarioSucursal';

const Welcome = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <Container fluid>
        {/* 🚀 Carrusel de promociones */}
        <PromotionCarousel />

        

        {/* Sección de horarios (manteniendo el diseño limpio) */}
        <div className='welcome-container1'>
          <HorarioSucursal/>
        {/* 🔥 Botón flotante sutil para abrir el modal */}
      {/*   <Button 
          variant="info" 
          onClick={handleShow} 
          className="floating-info-btn"
        >
          ℹ️
        </Button> */}
        </div>
      </Container>

      {/* 🔥 Modal con los pasos para realizar el pedido */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>🛒 Cómo realizar un pedido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ol>
            <li><b>Primer paso:</b> Selecciona la vianda correspondiente al dia para ver mas info.</li>
            <li><b>Segundo paso:</b> Si es la vianda que queres, agregala al pedido.</li>
            <li><b>Tercer paso:</b> Una vez agregada, volve apra atras para seguir agregando viandas.</li>
            <li><b>Cuarto paso:</b> Cuando tengas todo listo, haz clic en el botón de la vianda en la parte inferior derecha de la pantalla.</li>
            <li><b>Quinto paso:</b> Revisa tu pedido, fijate que esten todas las viandas que queres y toca el botón "Realizar pedido".</li>
            <li><b>Sexto paso:</b> Carga tus datos, forma de retiro/envío y método de pago (recuerda chequear las zonas de entrega).</li>
            <li><b>Último paso:</b> Toca el botón "Compartir pedido por WhatsApp" y envíanos tu pedido. 🚀</li>
          </ol>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <ItemsListContainer/>
    </>
  );
}

export default Welcome;
